export const REMOVED = 'removed';
export const ADDED = 'added';
export const MODIFIED = 'modified';
